
import React from "react";
import { Box, Button, Modal, Typography } from "@mui/material";

const style = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
  textAlign: "center",
};

interface ConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const SubmitConfirmationModal: React.FC<ConfirmationModalProps> = ({ open, onClose, onConfirm }) => {
  return (

<Modal open={open} onClose={onClose}>
  <Box sx={style}>
    <Typography variant="h6" gutterBottom>
      Confirm Submission
    </Typography>

    <Typography variant="body1" sx={{ mb: 2 }}>
      Please note, this is a <strong>one-time process</strong> and cannot be changed later.
    </Typography>

    <Typography variant="body1" sx={{ mb: 2 }}>
      Kindly review all details carefully before confirming.
    </Typography>

    <Typography variant="body1" sx={{ mb: 2, fontWeight: 'bold', color: 'error.main' }}>
      Total final amount will be considered as your final expense.
    </Typography>

    <Typography variant="body1" sx={{ mb: 3 }}>
      Are you sure you want to proceed with the submission?
    </Typography>

    <Box display="flex" justifyContent="center" gap={2}>
      <Button onClick={onClose} variant="outlined" color="secondary">
        Cancel
      </Button>
      <Button onClick={onConfirm} variant="contained" color="primary">
        Confirm
      </Button>
    </Box>
  </Box>
</Modal>

  );
};

export default SubmitConfirmationModal;
